export default "__VITE_ASSET__CbW3eAwo__"